module.exports = "<main-header></main-header>\n<basic-slider></basic-slider>"